export default "__VITE_ASSET__Cfbs4Pdy__"